import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';

const GreenCheckbox = withStyles({
  root: {
    color: '#F1873B',
    '&$checked': {
      color: '#F1873B',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function FrCheckBox(props) {

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <GreenCheckbox checked={props.checked} onChange={props.handleChange} {...props}/>
      <div style={{ paddingTop: '9px' }}>{props.text}</div>
    </div>
  );
}